import axios from "axios";
import { authToken, accessToken } from "../../../constants/config";
import { openIdb } from "./storageManager";
import cacheKeys from "./cacheKeys";

const { get, set, clear } = openIdb(
  "page_processor",
  "slug",
  1,
  "mykslug-" + getCookie("currentUser")
);

export function getCookie(key) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

export function DidTimeExpired(date, expiry) {
  const givendate = date.split("_");
  const currentDate = new Date();
  const msInSecond = 1000;
  const defaultExpiry = typeof expiry !== "undefined" ? expiry : 300;
  let startDate = new Date(
    givendate[0],
    givendate[1],
    givendate[2],
    givendate[3],
    givendate[4],
    givendate[5]
  );
  let endDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    currentDate.getHours(),
    currentDate.getMinutes(),
    currentDate.getSeconds()
  );
  let secondsLapsed = Math.round(Math.abs(endDate - startDate) / msInSecond);
  return {
    expired: secondsLapsed > defaultExpiry,
    secondsLapsed: secondsLapsed,
  };
}

export const getPageContent = async (slug) => {
  let pageContent = await get(slug);
  if (typeof pageContent === "undefined" || pageContent === null) {
    // console.log("Fetching page from Database...");
    return axios
      .get("http://local.language.com/" + slug, {
        headers: {
          Authorization: `${authToken}`,
          "Access-Token": `${accessToken}`,
        },
      })
      .then((response) => {
        if (
          typeof response.data.meta.module !== "undefined" &&
          response.data.meta.module !== "pageNotFound"
        ) {
          set(slug, response.data);
        }
        return response.data;
      });
  } else {
    return pageContent;
  }
};

export const cacheKeysExists = (key) => {
  let cacheKey = key.split("~")
  if(typeof cacheKey[1] === "undefined"){
    return typeof cacheKeys[key] !== "undefined";
  }
  cacheKey[1] = "<any>";
  // let cacheKey = key.split("_").map(function (item) {
  //   return isNaN(item) === false ? "<any>" : item;
  // });
  // console.log(cacheKeys,"cacheKey")
  // console.log(cacheKey.join("~"),"join")
  return typeof cacheKeys[cacheKey.join("~")] !== "undefined";
};

export const clearPageDB = async () => {
  return await clear();
}